export { urlRedirect, urlReplace } from './redirect';
export { isSafeUrl } from './utils';
export { historyPushState, historyReplaceState } from './history';
export { SafeAnchor } from './SafeAnchor';
export { windowOpen, safeWindowOpen } from './window';

//# sourceMappingURL=index.js.map